// Auto-generated from translation.csv; do not edit manually
export const enUS = {
  "accountGuide": {
    "content": "Open any game under the Touka brand, go to the in-game settings, bind your email, and you can enjoy special product discounts!",
    "title": "How to create an account?"
  },
  "bottomNav": {
    "home": "Home",
    "myOrders": "My Orders"
  },
  "common": {
    "loading": "Loading...",
    "noData": "No data",
    "server": "Server"
  },
  "auth": {
    "tokenExpired": "Login expired, please login again"
  },
  "errors": {
    "900400": "Internal parameter error",
    "900401": "Authentication failed",
    "900402": "Authentication expired",
    "1000000": "System error, please retry again later",
    "1000001": "System parameter error, please try again later",
    "1000002": "Captcha id or code is empty",
    "1000003": "Email invalid",
    "1000004": "Captcha code invalid",
    "1000005": "Email code already sent, please wait 5 minutes and try again",
    "1000006": "Email code send limit, please try again tomorrow",
    "1000007": "Email could not be empty",
    "1000008": "Code could not be empty",
    "1000009": "Code invalid",
    "1000010": "Get user login token error",
    "1000011": "Product is inactive, please try another product",
    "1000012": "The product has exceeded the purchase limit, please select another product",
    "1000013": "The product has been taken offline",
    "1000014": "Payment method not enabled",
    "1000015": "Your account does not support purchasing products, please contact customer service",
    "1000016": "Failed to create an order, please try again"
  },
  "footer": {
    "language": "Chinese (Simplified)",
    "privacyPolicy": "Privacy Policy",
    "refundPolicy": "Refund Policy",
    "termsOfService": "Terms of Service",
    "userSupport": "User Support",
    "downloadNow": "Download Now!"
  },
  "header": {
    "characterName": "Character Name",
    "gameServer": "Game Server",
    "selectGameServer": "Select game region",
    "greeting": "Hello",
    "loginPrompt": "Please click to log in",
    "switchServer": "Switch",
    "title": "Game Top-Up Center",
    "logout": "Log out"
  },
  "games": {
    "bamBamSquad": "BamBamSquad",
    "oopsieCroco": "Oopsie Croco"
  },
  "history": {
    "backToGameZone": "Back to game zone",
    "allGames": "All games",
    "empty": "No Orders",
    "filter": {
      "all": "All",
      "closed": "Closed",
      "completed": "Completed",
      "inProgress": "In Progress",
      "pendingDelivery": "Pending Shipment"
    },
    "orderTime": "Order Time:",
    "pendingAutoCancelPrefix": "Order will be cancelled in",
    "pendingAutoCancelSuffix": "automatically",
    "cancelOrder": "Cancel Order",
    "payOrder": "Pay",
    "cancelOrderConfirmTitle": "Confirm order cancellation?",
    "cancelOrderConfirmPrimary": "Confirm",
    "cancelOrderDismiss": "Not now",
    "cancelOrderSuccess": "Order cancelled",
    "cancelOrderFailed": "Could not cancel the order. Please try again.",
    "fetchOrderFailed": "Failed to get latest order information",
    "createOrderFailed": "Failed to create order",
    "payConfigError": "Payment configuration error, please contact support",
    "payRetryFailed": "Failed to retry payment, please try again",
    "status": {
      "cancelled": "Canceled",
      "completed": "Transaction Completed",
      "paid": "Paid",
      "pending": "Pending Payment",
      "shipped": "Shipped"
    }
  },
  "home": {
    "selectGame": "Select the game you want to top up",
    "selectGameMobileTitle": "Select a game",
    "selectGameParts": {
      "prefix": "Select the game you want to ",
      "keyword": "recharge",
      "suffix": ""
    },
    "noRoleAccount": "You don't have a character in this game yet. Please create one in the game before purchasing.",
    "noRoleRefreshPrefix": "Already created an account? Tap ",
    "noRoleRefreshAction": "Refresh",
    "noRoleRefreshing": "Refreshing…",
    "noRoleRefreshNotFound": "No character information found",
    "noRoleRefreshFailed": "Refresh failed. Please try again later."
  },
  "login": {
    "agreeTerms": {
      "and": "and",
      "prefix": "I have read and agree to",
      "privacy": "Privacy Policy",
      "terms": "Terms of Service"
    },
    "cancel": "Cancel",
    "bindGameGuide": "Game binding notice",
    "bindGameGuideContent": "Open any Touka game,\ngo to in-game Settings,\nbind your email, and you can enjoy\nspecial store discounts!",
    "captchaPlaceholder": "Verification Code",
    "invalidCaptcha": "Please enter a 4-digit verification code",
    "email": "Email",
    "emailNotBound": "We couldn't find your account. Please enter the email linked to your game account~",
    "emailPlaceholder": "Please enter your email",
    "keepLogin": "Keep me logged in for 15 days",
    "loading": "Logging in...",
    "loginToStore": "Log in to Touka Store",
    "noAccount": "Don't have an account yet?",
    "password": "Password",
    "passwordPlaceholder": "Please enter your password",
    "submit": "Log In",
    "title": "Log In",
    "invalidEmail": "Please enter a valid email address",
    "sendCodeFailed": "Failed to send verification code",
    "resendCodePrompt": "Please re-enter the captcha to resend the email verification code"
  },
  "logout": {
    "cancel": "Cancel",
    "confirm": "Confirm",
    "dontRemind": "Don't remind me next time",
    "failed": "Failed to log out. Please try again later.",
    "messageLine1": "After logging out, the login status on all devices used in the last 30 days",
    "messageLine2": "will expire.",
    "title": "Notice"
  },
  "menu": {
    "contactSupport": "Contact Customer Service",
    "gameList": "Game List",
    "myOrders": "My Orders"
  },
  "paymentSuccess": {
    "account": "Account:",
    "celebrationTitle": "Purchase Successful",
    "confirm": "Confirm",
    "getPaymentInfoFailed": "Failed to retrieve payment information",
    "loading": "Loading...",
    "orderDate": "Order Date:",
    "orderId": "Order Number:",
    "paymentMethod": "Payment Method:",
    "paypal": "PayPal",
    "price": "Price:",
    "purchaseContent": "Purchase Content:",
    "quantity": "Purchase Quantity:",
    "serverAndCharacter": "Region/Character:",
    "title": "Thank you",
    "total": "Total:",
    "unionPay": "UnionPay",
    "amountPaid": "Amount paid:",
    "closeModal": "Close"
  },
  "productModal": {
    "confirm": "Confirm",
    "purchaseDetails": "Purchase Details",
    "quantity": "Quantity:",
    "total": "Total:",
    "unitPrice": "Unit Price:"
  },
  "products": {
    "giftPacks": "Gift Packs",
    "diamond": "Diamond",
    "products": "Products",
    "vouchers": "Voucher",
    "toukaCoin": "Touka Coin",
    "toukaCoinBonusTip": "Shop at TOUKA Store and get an extra 10% bonus!",
    "superValue": "Great Value",
    "limitShort": "Limit",
    "remainingShort": "Time left",
    "giftPackLimitType": {
      "lifetime": "Lifetime Deal",
      "weekly": "Weekly Deal",
      "monthly": "Monthly Deal"
    },
    "howToUseVouchers": "How to use vouchers?",
    "voucherGuide": {
      "title": "How to use vouchers?",
      "step1": "1. Please check your in-game mailbox to claim the vouchers you purchased.",
      "step2": "2. You can check your voucher balance at the top of the in-game store tab. When you have enough vouchers to purchase a gift pack, vouchers will be used first for the purchase.",
      "backToProducts": "Back to Product List"
    },
    "luxuryVouchers": "Deluxe Vouchers"
  },
  "purchaseConfirm": {
    "card": "Credit/Debit Card",
    "confirm": "Confirm",
    "dontAskAgain": "Don't ask again within 30 days",
    "gameServer": "Game Server",
    "paymentMethods": "Supported Payment Methods",
    "paypal": "PayPal",
    "title": "Are you sure you want to make this purchase with this account?",
    "unionPay": "UnionPay Card"
  },
  "serverSelect": {
    "characterLabel": "Character Name",
    "characterPlaceholder": "Please select a character",
    "confirm": "Confirm",
    "noResults": "No results found",
    "serverPlaceholder": "Please enter the server name to search",
    "title": "Select Game Server"
  },
  "support": {
    "cancel": "Cancel",
    "copied": "Copied",
    "copy": "One-click copy",
    "description": "Please send your detailed information to the official support email.",
    "title": "Customer Support"
  },
  "verification": {
    "back": "Return",
    "enterCode": "Please enter the verification code to continue",
    "incorrectCode": "Verification code is incorrect",
    "invalidCode": "Please enter a 6-digit verification code",
    "noCode": "Did not receive the verification code?",
    "sentTo": "Verification code sent to",
    "submit": "Submit",
    "submitting": "Submitting..."
  }
} as const;
